import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";

const ServiceMenuAccordian = ({ title, slug, service_items }) => {
    const param = useParams();
    // Auto-open the accordion if the current category matches the slug
    const [isOpen, setIsOpen] = useState(slug === param.category);

    useEffect(() => {
        if (slug === param.category) setIsOpen(true);
    }, [param.category, slug]);

    return (
        <div className="border-b border-gray-100 last:border-0 pb-2">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`w-full flex items-center justify-between py-3 text-left transition-colors ${
                    slug === param.category ? "text-brand-600" : "text-gray-900"
                }`}
            >
                <span className="font-bold uppercase tracking-tight text-md">
                    {title}
                </span>
                <svg 
                    className={`w-4 h-4 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} 
                    fill="none" viewBox="0 0 24 24" stroke="currentColor"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {/* Sub-items list */}
            <div className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-125 opacity-100" : "max-h-0 opacity-0"}`}>
                <div className="flex flex-col space-y-1 mt-2 mb-4">
                    {service_items?.map((item, index) => (
                        <Link
                            key={index}
                            to={`/services/${slug}/${item?.slug}`}
                            className={`group flex items-center px-4 py-2 text-md font-medium rounded-lg transition-all ${
                                item?.slug === param.item 
                                ? "bg-brand-500 text-white shadow-lg" 
                                : "text-gray-500 ha:bg-gray-50 ha:text-brand-600"
                            }`}
                        >
                            <div className={`w-1.5 h-1.5 rounded-lg mr-3 ${
                                item?.slug === param.item ? "bg-white" : "bg-gray-300 gh:bg-brand-500"
                            }`} />
                            {item?.title}
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ServiceMenuAccordian;